import { cssVars } from '@/styles/Themes/cssVars';
import styled from 'styled-components';
import Text from '@/styles/Themes/Text';

export const TotalPrice = styled.div`
    text-align: center;
    color: ${cssVars.fg_gray1_white};
    ${Text.Mobile.heading2};
`;

export const Dollar = styled.span`
    ${Text.Mobile.heading4.bold};
`;
